export { default } from './Samples';



// WEBPACK FOOTER //
// ./src/components/templates/Samples/index.js